import { RootState } from 'store';

const PaymentTypesLookupState = (state: RootState) => state.lookups.paymentTypes;

export const selectPaymentTypes = (state: RootState) => PaymentTypesLookupState(state).rows;
